import { Component } from '@angular/core';

export interface MaintenanceDiagnostic {
	status: number;
	errorCode: string;
	technicalStatus: string;
	diagnosis: string;
	apiErrorCode: string;
	requestId: string;
	clientReference: string;
	occurredAt: string;
	displayTime: string;
	connection: 'online' | 'offline' | 'unbekannt';
	networkType: string;
	frontend: string;
	build: string;
	server: string;
	request: string;
	browser: string;
	retryAfter: string;
}

@Component({
	selector: 'lib-shared-maintenance-notification',
	imports: [],
	templateUrl: './maintenance-notification.component.html',
	styleUrl: './maintenance-notification.component.scss'
})
export class MaintenanceNotificationComponent {
	diagnostic: MaintenanceDiagnostic = {
		status: 503,
		errorCode: 'HTTP-503',
		technicalStatus: 'HTTP 503 / Service Unavailable',
		diagnosis: 'Der Server ist vorübergehend nicht verfügbar.',
		apiErrorCode: 'nicht verfügbar',
		requestId: 'nicht verfügbar',
		clientReference: 'nicht verfügbar',
		occurredAt: '',
		displayTime: '',
		connection: 'unbekannt',
		networkType: 'unbekannt',
		frontend: 'unbekannt',
		build: 'unbekannt',
		server: 'unbekannt',
		request: '---',
		browser: 'unbekannt',
		retryAfter: 'nicht angegeben'
	};

	dismiss: () => void = () => undefined;
	copyState = '';

	get titleDe(): string {
		if (this.diagnostic.status === 0) {
			return 'Verbindungsproblem';
		}
		if (this.diagnostic.status === 429) {
			return 'Zu viele Versuche';
		}
		if (this.diagnostic.status === 500) {
			return 'Technischer Fehler';
		}
		if ([408, 504].includes(this.diagnostic.status)) {
			return 'Zeitüberschreitung';
		}
		return 'Server nicht erreichbar';
	}

	get titleEn(): string {
		if (this.diagnostic.status === 0) {
			return 'Connection problem';
		}
		if (this.diagnostic.status === 429) {
			return 'Too many attempts';
		}
		if (this.diagnostic.status === 500) {
			return 'Technical error';
		}
		if ([408, 504].includes(this.diagnostic.status)) {
			return 'Request timed out';
		}
		return 'Server unavailable';
	}

	async copyDiagnosticDetails(): Promise<void> {
		const details = [
			'LorenzMesse Fehlerdiagnose',
			`Fehlercode: ${this.diagnostic.errorCode}`,
			`Technischer Status: ${this.diagnostic.technicalStatus}`,
			`Diagnose: ${this.diagnostic.diagnosis}`,
			`API-Fehlercode: ${this.diagnostic.apiErrorCode}`,
			`Request-ID: ${this.diagnostic.requestId}`,
			`Client-Referenz: ${this.diagnostic.clientReference}`,
			`Zeit: ${this.diagnostic.occurredAt}`,
			`Browser-Netzwerkstatus: ${this.diagnostic.connection}`,
			`Netzwerktyp: ${this.diagnostic.networkType}`,
			`Frontend: ${this.diagnostic.frontend}`,
			`Build: ${this.diagnostic.build}`,
			`Server: ${this.diagnostic.server}`,
			`Anfrage: ${this.diagnostic.request}`,
			`Browser/Gerät: ${this.diagnostic.browser}`,
			`Retry-After: ${this.diagnostic.retryAfter}`
		].join('\n');

		try {
			await navigator.clipboard.writeText(details);
			this.copyState = 'Details wurden kopiert.';
		} catch {
			this.copyState = 'Kopieren nicht möglich. Bitte nenne uns Fehlercode und Uhrzeit.';
		}
	}
}
